var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e994f99f-c4fb-4d3e-b2ce-bb9a9f3daa24",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.01 12.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acc3fb4b-bc18-4787-bb0b-76663782c3d0",
    "data-name": "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f4a65d85-042a-406e-a8a7-f2dd1f4b8480",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    className: "ad46052c-4f44-405b-b1a1-b8e43415323e",
    d: "M12.26,4.13v6.12H1.76V4.07L0,3v8.3a.93.93,0,0,0,.87,1H13.13a1,1,0,0,0,.88-1V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2c23e99-1dfd-483e-ac16-91d6be4d0282",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    className: "ad46052c-4f44-405b-b1a1-b8e43415323e",
    d: "M13.13,0H.88A.89.89,0,0,0,0,.9.34.34,0,0,0,0,1V2.4L7,6.9l7-4.4V1a.89.89,0,0,0-.78-1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2f6eaaf43dcfae2838eaa1c0b33c452e.svg";
export { ForwardRef as ReactComponent };